import React from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
//import {Styles} from './Styles';

interface Props {
    ok():void,
}

const OKButton = (props:Props)=> {
    //const classes = Styles.base();
    return (
        <React.Fragment>
            <Tooltip title="部屋を見る"><Button variant="outlined" color="primary" style={{color:"white",width:"100%"}} onClick={props.ok}>
                部屋を見る
            </Button></Tooltip>
        </React.Fragment>
    );
}

export default OKButton;
